import { render, staticRenderFns } from "./DeliveryDownloadAccessForm.vue?vue&type=template&id=ee2580fe&scoped=true&"
import script from "./DeliveryDownloadAccessForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDownloadAccessForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDownloadAccessForm.vue?vue&type=style&index=0&id=ee2580fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2580fe",
  null
  
)

export default component.exports